import React from 'react';
import { SOLES } from '../../../common/types/monedaType';
import inventarioService from '../../../service/logistica/inventarioService';
import almacenService from '../../../service/administracion/almacenService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import monedaService from '../../../service/administracion/monedaService';
import productoService from '../../../service/administracion/productoService';
import global from '../../../common/utility/global';

import Header from '../../../components/Header';
import Filters from './Filters';
import EstablecimientoTable from './EstablecimientoTable';

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            establecimientos: [],
            almacenes: [],
            monedas: [], 
            productos: [],
            productosAutocomplete:[],
            almacenesLoading: false,
            establecimientosLoading: false,
            monedasLoading: false,
            loadingExcel:false,
            filter: {
                idEstablecimiento: '0',
                idAlmacen: '0',
                fechaHastaFormat: global.fetchCurrentDateStr(),
                idProducto: 0,
                idMoneda: SOLES,
                idTipoReporteInventario: 1
            },
            tiposReporteInventario: [
                { id: 1, nombre: "Inventario Permanente Valorizado" },
                { id: 2, nombre: "Inventario Permanente de Unidades Físicas" },
              ],
            inventarioDataSource: []
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter };
        }
    };

    handleChange = async (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });

        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: undefined },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
    };

    handleClearFilters = () => {
        var filter = {
            idEstablecimiento: '0',
            idAlmacen: '0',
            fechaHastaFormat: global.fetchCurrentDateStr(),
            idProducto: 0,
            idMoneda: SOLES,
            idTipoReporteInventario: 1
        };
        this.setState({ filter });
    };

    handleSearchAutocomplete = (value) => {
        const result = this.state.productos.filter(item => {
            return (item.nombre).toUpperCase().match(value.toUpperCase());
        }).slice(0, 75);
        this.setState({ productosAutocomplete: result });
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: 0
            }
        });
    }

    handleSearchInventarioEstablecimiento = async () => {
        const inventarioDataSource = await inventarioService.establecimientoAlmacen(this.state.filter);
        this.setState({
            inventarioDataSource: inventarioDataSource ? inventarioDataSource : []
        });
    }

    handleSearchInventarioProducto = async (item) => {
        var filter = {
            idAlmacen: item.id,
            fechaHastaFormat: this.state.filter.fechaHastaFormat,
            idProducto: this.state.filter.idProducto,
            idMoneda: this.state.filter.idMoneda
        }
        const productosInventario = await inventarioService.producto(filter);

        var newInventarioDataSource = [];

        this.state.inventarioDataSource.forEach(element => {
            var item = { ...element };
            newInventarioDataSource.push(item);
        });

        newInventarioDataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.id) {
                    almacen.productos = productosInventario;
                }
            });
        });

        this.setState({ inventarioDataSource: newInventarioDataSource });
    }

    handleSearchInventarioValorizadoMovimiento = async (item) => {
        
        var filter = {
            idAlmacen: item.idAlmacen,
            fechaHastaFormat: this.state.filter.fechaHastaFormat,
            idProducto: item.id,
            idMoneda: this.state.filter.idMoneda
        }

        const movimientosInventario = await inventarioService.inventarioValorizado(filter);

        var newInventarioDataSource = [];

        this.state.inventarioDataSource.forEach(element => {
            var item = { ...element };
            newInventarioDataSource.push(item);
        });

        newInventarioDataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.idAlmacen) {
                    almacen.productos.forEach(producto => {
                        if(producto.id === item.id) {
                            producto.movimientos = movimientosInventario;
                        }
                    });
                }
            });
        });

        this.setState({ inventarioDataSource: newInventarioDataSource });
    }

    handleSearchInventarioUnidadesFisicasMovimiento = async (item) => {
        var filter = {
            idAlmacen: item.idAlmacen,
            fechaHastaFormat: this.state.filter.fechaHastaFormat,
            idProducto: item.id,
            idMoneda: this.state.filter.idMoneda
        }

        const movimientosInventario = await inventarioService.unidadesFisicas(filter);

        var newInventarioDataSource = [];

        this.state.inventarioDataSource.forEach(element => {
            var item = { ...element };
            newInventarioDataSource.push(item);
        });

        newInventarioDataSource.forEach(establecimiento => {
            establecimiento.almacenes.forEach(almacen => {
                if (almacen.id === item.idAlmacen) {
                    almacen.productos.forEach(producto => {
                        if(producto.id === item.id) {
                            producto.movimientos = movimientosInventario;
                        }
                    });
                }
            });
        });

        this.setState({ inventarioDataSource: newInventarioDataSource });
    }

    handleExportExcelDetallado = async () => {
        this.setState({ loadingExcel: true });
        var response = await inventarioService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Inventario Detallado.xlsx");
    }

    handleExportExcelResumido = async () => {
        this.setState({ loadingExcel: true });
        var response = await inventarioService.excelResumido(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Inventario Resumido.xlsx");
    }

    async componentDidMount() {
        this.setState({
            establecimientosLoading: true,
            monedasLoading: true
        });

        const establecimientos = await establecimientoService.principales();
        const monedas = await monedaService.listar();
        const productos = await productoService.listar();
        
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        this.setState({
            establecimientos: establecimientos ? establecimientos : [],
            monedas: monedas ? monedas : [],
            productos: productos_filter ? productos_filter : [],
            establecimientosLoading: false,
            monedasLoading: false
        });
    }

    render() {
        return (
            <>
                <Header
                    title="Inventario SUNAT"
                    onSearch={this.handleSearchInventarioEstablecimiento}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    productos={this.state.productosAutocomplete}
                    tiposReporteInventario={this.state.tiposReporteInventario}
                    establecimientosLoading={this.state.establecimientosLoading}
                    almacenesLoading={this.state.almacenesLoading}
                    monedasLoading={this.state.monedasLoading}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                <EstablecimientoTable
                    dataSource={this.state.inventarioDataSource}
                    filter={this.state.filter}
                    loadingExcel={this.state.loadingExcel}
                    onSearchInventarioProducto={this.handleSearchInventarioProducto}
                    onSearchInventarioValorizadoMovimiento={this.handleSearchInventarioValorizadoMovimiento}
                    onSearchInventarioUnidadesFisicasMovimiento={this.handleSearchInventarioUnidadesFisicasMovimiento}
                    onExportExcelDetallado={this.handleExportExcelDetallado}
                    onExportExcelResumido={this.handleExportExcelResumido}
                />
            </>
        )
    }
}